<section *ngIf="processing">
    <h2>Processing...</h2>
    <mat-progress-bar mode="indeterminate" color="warn" aria-label="processing...">
    </mat-progress-bar>
  </section>
<form #form="ngForm" [formGroup]="retestService.searchForm" class="form-field-full">
    <div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
        <div fxFlex="50.00" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
            <h2 class="noMarginHeader">
                <mat-icon>search</mat-icon> Search Retest Schedule
            </h2>
        </div>
    </div>
    <div fxLayout="row wrap" class="matero-row">
        <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
            <mat-card>
                <div fxLayout="row wrap" fxLayoutGap="8px grid">
                    <div fxFlex="33.33" fxFlex.lt-sm="100">
                        <mat-form-field appearance="standard">
                            <mat-label>OHA Retest Id</mat-label>
                            <input id="id" name="id" formControlName="id" matInput />
                        </mat-form-field>
                    </div>
                    <div fxFlex="33.33" fxFlex.lt-sm="100">
                        <mat-form-field appearance="standard">
                            <mat-label>Sample Id</mat-label>
                            <input id="sampleId" name="sampleId" formControlName="sampleId" matInput />
                        </mat-form-field>
                    </div>
                    <div fxFlex="33.33" fxFlex.lt-sm="100">
                        <mat-form-field appearance="standard">
                            <mat-label>Voucher Identifier</mat-label>
                            <input id="voucherIdentifier" name="voucherIdentifier" formControlName="voucherIdentifier"
                                matInput />
                        </mat-form-field>
                    </div>
                </div>
                <div fxLayout="row wrap" fxLayoutGap="8px grid">
                    <div fxFlex="33.33" fxFlex.lt-sm="100">
                        <mat-form-field appearance="standard">
                            <mat-label>Year</mat-label>
                            <mat-select id="retestYear" name="retestYear" formControlName="retestYear">
                                <mat-option value=""></mat-option>
                                <mat-option *ngFor="let item of retestService.retestYears" [value]="item.id">{{item.id}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div fxFlex="33.33" fxFlex.lt-sm="100">
                        <mat-form-field appearance="standard">
                            <mat-label>Quarter</mat-label>
                            <mat-select id="retestQuarter" name="retestQuarter" formControlName="retestQuarter">
                                <mat-option value=""></mat-option>
                                <mat-option *ngFor="let item of retestService.retestQuarters" [value]="item.id">
                                    Quarter {{item.id}} (Q{{item.id}})
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div fxFlex="33.33" fxFlex.lt-sm="100">
                        <mat-form-field appearance="standard">
                            <mat-label>Tier</mat-label>
                            <mat-select id="tier" name="tier" formControlName="tier">
                                <mat-option value=""></mat-option>
                                <mat-option *ngFor="let item of retestService.tiers" [value]="item.id">Tier {{item.id}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div fxLayout="row wrap" fxLayoutGap="8px grid">
                    <div fxFlex="33.33" fxFlex.lt-sm="100">
                        <mat-form-field appearance="standard">
                            <mat-label>Status</mat-label>
                            <mat-select id="isComplete" name="isComplete" formControlName="isComplete">
                                <mat-option value=""></mat-option>
                                <mat-option value="Yes">Completed</mat-option>
                                <mat-option value="No">Not Completed</mat-option>
                                <mat-option value="Incomplete">Incomplete/Expired</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div fxFlex="33.33" fxFlex.lt-sm="100">
                        <mat-form-field appearance="standard">
                            <mat-label>Well County</mat-label>
                            <mat-select id="wellCounty" name="wellCounty" formControlName="wellCounty">
                                <mat-option value=""></mat-option>
                                <mat-option *ngFor="let item of sharedService.countyList" [value]="item">{{item}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div fxFlex="33.33" fxFlex.lt-sm="100">
                        <mat-checkbox formControlName="mismatchedTier"> Mismatched Nitrate Tiers</mat-checkbox>
                    </div>
                </div>
            </mat-card>
        </div>
    </div>

    <!-- buttons -->
    <div fxLayout="row wrap" class="matero-row">
        <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col">
            <mat-card>
                &nbsp;&nbsp;
                <button type="submit" id="submitButtonSearch" (click)="onSubmit()" mat-raised-button color="primary"
                    title="Search" [disabled]='processing'>Search</button>
                &nbsp;&nbsp;
                <button type="submit" id="submitButtonReset" (click)="reset()" mat-raised-button color="basic"
                    title="Clear" [disabled]='processing'>Clear</button>
                    &nbsp;&nbsp;
                <button type="submit" id="submitButtonBulkOperation" (click)="bulkOperation()" mat-raised-button color="primary"
                    title="Bulk Operation" [disabled]='processing || !showResults'>Bulk Operation</button>
            </mat-card>
        </div>
    </div>
</form>

<!-- results -->
<mat-card [hidden]="!showResults">
    <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
        <strong class="noMarginHeader">Results ({{retestService.searchResultsCount}}) </strong>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <mat-form-field style="width:200px;">
            <input (keyup)="filterTable($event)" placeholder="Filter results" matInput />
        </mat-form-field>
        <br />
        <mat-table [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8"
            style="overflow-x: auto;">
            <mat-row>Results ({{retestService.searchResultsCount}}) </mat-row>
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            <ng-container matColumnDef="select">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">
                    <input id="selectAll" name="selectAll" type="checkbox" (click)="updateAll()"
                                [(ngModel)]="selectAll" />
                </mat-header-cell>
                <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
                    <input type="checkbox" [checked]="result.isSelected"
                                (change)="result.isSelected = !result.isSelected" />
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="id">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Id</mat-header-cell>
                <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
                    <a href="javascript:void(0)" (click)="editRetest(result.id)"
                        title="Edit Retest Schedule {{result.id}}">{{result.id}}</a>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="wellId">
                <mat-header-cell *matHeaderCellDef mat-sort-header xFlex.lt-sm="100">Well Id</mat-header-cell>
                <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
                    <span *ngIf="result.wellId == 0">&nbsp;</span>
                    <span *ngIf="result.wellId > 0">
                        <a [routerLink]="['/well/edit', result.wellId]" title="Edit Well {{result.wellId}}">{{result.wellId}}</a>
                    </span>
                </mat-cell>
            </ng-container>            
            <ng-container matColumnDef="orgininalSampleId">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Original <br /> Sample
                    Id</mat-header-cell>
                <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
                    <span *ngIf="result.householdId == 0">&nbsp;</span>
                    <span *ngIf="result.orgininalSampleId > 0">
                        <a href="javascript:void(0)" (click)="editSample(result.orgininalSampleId)"
                            title="View Original Sample {{result.orgininalSampleId}}">{{result.orgininalSampleId}}</a>
                    </span>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="retestSampleId">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Retest <br /> Sample
                    Id</mat-header-cell>
                <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
                    <span *ngIf="result.householdId == 0">&nbsp;</span>
                    <span *ngIf="result.retestSampleId > 0">
                        <a href="javascript:void(0)" (click)="editSample(result.retestSampleId)"
                            title="View Retest Sample {{result.retestSampleId}}">{{result.retestSampleId}}</a>
                    </span>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="voucherIdentifier">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="14" fxFlex.lt-sm="100">Voucher <br />
                    Identifier</mat-header-cell>
                <mat-cell *matCellDef="let result" fxFlex="14" fxFlex.lt-sm="100">
                    <span *ngIf="result.voucherId == 0">&nbsp;</span>
                    <span *ngIf="result.voucherId > 0">
                        <a href="javascript:void(0)" (click)="editVoucher(result.voucherId)"
                            title="View Voucher Identifier {{result.voucherIdentifier}}">{{result.voucherIdentifier}}</a>
                    </span>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="voucherStatus">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100" fxFlex="8">Voucher Status</mat-header-cell>
                <mat-cell *matCellDef="let result" fxFlex.lt-sm="100" fxFlex="8">
                    {{result.voucherStatus}}
                    
                    <mat-icon class="error" [hidden]="result.voucherStatus=='Issued'" >warning</mat-icon>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="retestYear">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100" fxFlex="8">Year</mat-header-cell>
                <mat-cell *matCellDef="let result" fxFlex.lt-sm="100" fxFlex="8">{{result.retestYear}}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="retestQuarter">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100" fxFlex="8">Quarter</mat-header-cell>
                <mat-cell *matCellDef="let result" fxFlex.lt-sm="100" fxFlex="8">
                    Q{{result.retestQuarter}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="tier">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100" fxFlex="8">Tier</mat-header-cell>
                <mat-cell *matCellDef="let result" fxFlex.lt-sm="100" fxFlex="8">
                    Tier {{result.tier}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="dueBy">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100" fxFlex="10">Due Date</mat-header-cell>
                <mat-cell *matCellDef="let result" fxFlex.lt-sm="100" fxFlex="10">
                    {{result.dueBy}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="isComplete">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex="5" fxFlex.lt-sm="100">Status</mat-header-cell>
                <mat-cell *matCellDef="let result" fxFlex="5" fxFlex.lt-sm="100">
                    <span *ngIf="result.isComplete == 'True'" class="success">Complete</span>
                    <span *ngIf="result.isComplete == 'False' && result.incomplete != true" class="error">Not Completed</span>
                    <span *ngIf="result.incomplete == true" class="warn">Incomplete</span>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="completedDate">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100" fxFlex="10">Completed Date</mat-header-cell>
                <mat-cell *matCellDef="let result" fxFlex.lt-sm="100" fxFlex="10">
                    {{result.completedDate}}
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="highestNitrate">
                <mat-header-cell *matHeaderCellDef mat-sort-header fxFlex.lt-sm="100">Highest Voucher Nitrate</mat-header-cell>
                <mat-cell *matCellDef="let result" fxFlex.lt-sm="100">
                  <span [hidden]="result.highestNitrateSampleId == 0">
                    Value: <a href="javascript:void(0)" (click)="editSample(result.highestNitrateSampleId)"
                    title="View Highest Sample {{result.highestNitrateSampleId}}">{{result.highestNitrateValue}}</a> <br />
                    Tier: {{result.highestNitrateTier}}                    
                    <mat-icon class="error" [hidden]="result.tier==result.highestNitrateTier">warning</mat-icon>
                  </span>
                  <span *ngIf="result.highestNitrateSampleId == 0">
                    <mat-icon class="error" [hidden]="result.tier==result.highestNitrateTier" >warning</mat-icon>
                    Invalid Data.
                  </span>
                </mat-cell>
              </ng-container>
            <ng-container matColumnDef="actions">
                <mat-header-cell *matHeaderCellDef fxFlex="5">Actions</mat-header-cell>
                <mat-cell *matCellDef="let result" fxFlex="5">
                    &nbsp;&nbsp;
                    <a href="javascript:void(0)" (click)="deleteRetest(result.id)"
                        title="Delete Retest Schedule {{result.id}}">
                        <mat-icon>delete</mat-icon>
                    </a>
                </mat-cell>
            </ng-container>
        </mat-table>
        <br />
        <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 20, 50]" #TablePaginator="matPaginator"
            showFirstLastButtons></mat-paginator>
    </div>
</mat-card>